"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var isWeekdayIndex = exports.isWeekdayIndex = function isWeekdayIndex(value) {
  return [0, 1, 2, 3, 4, 5, 6].indexOf(value) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-calendar/lib/utils/validators.js
// module id = 187
// module chunks = 0